export const AI_CONVERSATIONS_ENDPOINT = 'api/ai-agents/conversations/'

export const AI_BILLING_BALANCE_ENDPOINT = 'api/ai-agents/billing/balance/'

export const AI_FINANCE_ACCESS_ENDPOINT = 'api/ai-agents/finance/access/'

export const AI_BRAIN_ORIGIN_PATH = 'model'

// Fake-200 the brain sends when it can't answer (balance / model down).
export const AI_LLM_UNAVAILABLE_REPLY_MARKERS = [
  'balance is exhausted',
  'top up your balance',
]

export const AI_BRAIN_TOKEN_EXPIRED_DETAIL = 'token_expired'

export const AIErrorCode = {
  FinanceAccessDenied: 'finance_access_denied',
  FinanceAccessRevoked: 'finance_access_revoked',
  SourceUnavailable: 'source_unavailable',
}

export const AIConversationOriginType = {
  AskElsewhere: 'ask_elsewhere',
}

export const AIConversationGenerationStatus = {
  Failed: 'failed',
  Idle: 'idle',
  Running: 'running',
}

export const AIConversationMessageEventCode = {
  Failed: 'generation_failed',
  Stopped: 'generation_stopped',
}

export const AIConversationStopOutcome = {
  Completed: 'completed',
  Stopped: 'stopped',
  StopRequested: 'stop_requested',
}
